import React from 'react';
import ReactDOM from 'react-dom';
import { BaseButton } from '@repo/common';

const SUPPORT_EMAIL = 'hello@ko-ready.com';

const QuickAddBlockedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleSupportClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  };

  return ReactDOM.createPortal(
    <div
      className='fixed inset-0 z-[1000000000] flex items-end justify-center bg-surface-black40 md:items-center'
      onClick={onClose}
    >
      <div
        className='w-full rounded-t-[40px] bg-grayscale-gray01 px-[40px] pb-[40px] pt-[16px] soft-70-top md:w-[500px] md:rounded-[30px] md:px-[60px] md:py-[40px] md:soft-70'
        onClick={(event) => event.stopPropagation()}
      >
        <div className='mx-auto mb-[50px] h-[6px] w-[46px] rounded-2xl bg-grayscale-gray02 md:hidden' />

        <div className='flex flex-col items-center text-center md:min-h-[168px] md:pb-[40px]'>
          <h2 className='typo-title3 mb-3 text-text-primary md:typo-title1'>
            Booking unavailable
          </h2>
          <p className='typo-b14 max-w-[380px] whitespace-pre-line text-text-secondary md:typo-b16Strong'>
            {
              'You cannot book this workshop at\nthe moment. Please contact support if you\nthink this is a mistake.'
            }
          </p>
          <BaseButton
            type='text'
            size='s'
            htmlType='button'
            hideIcon
            typo={false}
            isStatic
            onClick={handleSupportClick}
            textWrapperClass='h-auto'
            className='h-auto min-w-0 cursor-pointer rounded-none border-0 bg-transparent typo-b12 mt-[2px] px-[6px] py-[3px] text-text-secondary underline md:typo-b14'
          >
            Contact support
          </BaseButton>
        </div>

        <BaseButton
          type='secondary'
          size='xl'
          hideIcon
          width='100%'
          bgclass='bg-grayscale-gray02'
          borderclass='border-grayscale-gray02'
          textclass='text-text-secondary'
          onClick={onClose}
        >
          Got it
        </BaseButton>
      </div>
    </div>,
    document.body,
  );
};

export default QuickAddBlockedModal;
